UserPassword = {
    initCheckPasswordFunction: function (el) {
        var me = this;

        if ( typeof el == "undefined" || !el || el == null ) {
            return false;
        }

        el.on('keyup change', function () {
            me.check_password($(this).val());
        });
    },
    check_password: function (pwd) {

        var span_bar   = document.getElementById("pwd_bar");
        var span_meter = document.getElementById("pwd_meter");

        var floatEntropy;
        var intBase = 0;
        var intPwdLen;
        var strUnique="";
        var intStrength = 0;
        var x;
        var barColor;

        intPwdLen = pwd.length;

        if (pwd.match(/[a-z]/)) {
            intBase = intBase + 26;
        }

        if (pwd.match(/[A-Z]/)) {
            intBase = intBase + 26;
        }

        if (pwd.match(/[0-9]/)) {
            intBase = intBase + 10;
        }

        if (pwd.match(/[\W_]/)) {
            intBase = intBase + 33;
        }

        for (x = 0; x < intPwdLen; x++) {
            var intMatches = 0;
            for (var i = x+1; i < intPwdLen; i++) {
                if (pwd.charAt(x) == pwd.charAt(i))
                    intMatches = intMatches + 1;
            }
            if (intMatches < 2)
                strUnique = strUnique + pwd.charAt(x);
        }
        var strUniqueLen = strUnique.length;

        floatEntropy = Math.pow(intBase, strUniqueLen);

        x = floatEntropy;
        while (x >= 10) {
            intStrength = intStrength + 1;
            x = x / 10;
        }

        if (intStrength > 50) {
            intStrength = 50;
        }

        var  strDesc = "";

        if (intStrength <= 5) {
            strDesc = 'Weak';
            barColor = "Red";
        } else if (intStrength <= 10) {
            strDesc = 'Fair';
            barColor = "Orange";
        } else if (intStrength <= 15) {
            strDesc = 'Good';
            barColor = "yellow";
        } else if (intStrength <= 20) {
            strDesc = 'Strong';
            barColor = "GreenYellow";
        } else if (intStrength > 20) {
            strDesc =  'Very strong';
            barColor = "Green";
        }

        span_bar.innerHTML             = "";
        span_bar.style.width           = "100%";
        span_bar.style.height          = "8px";
        span_bar.style.border          = "1px solid #000000";
        span_bar.style.backgroundColor = barColor;
        span_bar.style.margin          = "0px";
        span_bar.style.padding         = "0px";
        span_meter.innerHTML           = strDesc + "&nbsp;";

        if (intPwdLen > 0) {
            return(intStrength);
        }


    }
};
